import axios from 'axios'
import moment from 'moment';
import qs from 'qs';
import Constant from '../constant';
import {dismissLoading} from '../libs/LoadingUtil';
import * as Cache from "../cache/Cache";

const HTTP_RESP_CODE = {
  RESP_CODE_SUCCESS:200//请求成功
}

axios.defaults.headers = {
  'Content-Type': 'application/json;charset=utf-8',
}
axios.defaults.timeout = 60 * 1000;
//默认是false，意思就是不携带cookie信息
axios.defaults.withCredentials = true;


//添加请求拦截器
axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

//添加响应拦截器
axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error)
})

const serializeJSON = data => {
  if (!data) {
    return '';
  }
  return Object.entries(data).map(([key, value]) => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  }).join('&');
};

export const get = (body, success = () => {
}, fail = () => {
}) => {
  let newBody = commonParam(body);

  let serialzeBody = serializeJSON(newBody);
  let realBody = serialzeBody ? '?' + serialzeBody : '';
  const requestParams = {
    method: 'get',
    url: process.env.API_HOST + 'execute' + realBody,
  }
  axios(requestParams).then(res => {
    handleResp(body, res, requestParams, success, fail);
    
  })
}

export const post = (url,success = () => {
}, fail = () => {
}) => {
  const requestParams={
    method: 'post',
    url: process.env.API_HOST + url,
    data: {},
  }
  axios(requestParams).then(res => {
    handleResp({}, url, res, 'post', requestParams, success, fail);
  })

}

export const  postUrl = (body, url, success = () => {
}, fail = () => {
}) => {
  let newBody = commonParam(body);
  let xcSession = Cache.getSsoSession();
  let clientConnSessionid = Cache.getClientConnSessionid();
  const requestParams = {
    method: 'post',
    url: process.env.API_HOST + url,
    type: 'json',
    data: JSON.parse(newBody),
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      'xc_sso_sessionid': xcSession,
      'xc_client_sessionid': clientConnSessionid,
    }
  }
  axios(requestParams).then(res => {
    //console.info("then:" + res.status);
    // handleResp(body, res, success, fail);
    handleResp(body, url, res, 'post', requestParams, success, fail);
  }).catch(error=>{
    console.log(error);
    failCallback(body, fail, createFailRespObj(error.message));
  })
}

export const downloadUrl = (body, url, success = () => { }, fail = () => { }) => {
  if(!body.noLoading) {
    showLoading()
  }
  // let clientSessionId = Cache.getClientSession() == "" || Cache.getClientSession() == "undefined" || Cache.getClientSession() == undefined ? "" : Cache.getClientSession();
  let newBody = commonParam(body);
  // let bodyHmac = '';
  // if (clientSessionId != '') {
  //   bodyHmac = HmacSHA1(newBody, clientSessionId)
  // }

  let bodyJson = JSON.parse(newBody)
  let ssoSessionId = Cache.getSsoSession() == "" || Cache.getSsoSession() == "undefined" || Cache.getSsoSession() == undefined ? "" : Cache.getSsoSession();
  let authorization = ssoSessionId == "" ? "" : 'bearer ' + ssoSessionId;

  const requestParams = {
    method: 'post',
    url: process.env.API_HOST + url,
    type: 'json',
    data: bodyJson,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      // 'Content-Signature': bodyHmac,
      // 'xc_client_sessionid': clientSessionId,
      'xc_sso_sessionid': ssoSessionId,
      'Authorization': authorization
    },
    responseType: 'blob'
  }
  axios(requestParams).then(res => {
    handleResp(body, url, res, 'downloadUrl', requestParams, success, fail);
  }).catch(error => {
    failCallback(body, fail, createFailRespObj(error.message));
  })
}

export const uploadFile = (formData, url, success = () => { }, fail = () => { }) => {

 
  // let clientSessionId = Cache.getClientConnSessionid() == "" || Cache.getClientConnSessionid() == "undefined" || Cache.getClientConnSessionid() == undefined ? "" : Cache.getClientConnSessionid();
  // let newBody = commonParam(body);
  // let bodyHmac = '';
  // if(clientSessionId != ''){
  //   bodyHmac = HmacSHA1(newBody, clientSessionId)
  // }

  // let bodyJson = JSON.parse(newBody)
  let ssoSessionId = Cache.getSsoSession() == "" || Cache.getSsoSession() == "undefined" || Cache.getSsoSession() == undefined ? "" : Cache.getSsoSession();
  let authorization = ssoSessionId == "" ? "" : 'bearer ' + ssoSessionId;

  const requestParams = {
    method: 'post',
    url: process.env.API_HOST + url,
    // type:'json',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      // 'Content-Signature': bodyHmac,
      'xc_client_sessionid': clientSessionId,
      'xc_sso_sessionid': ssoSessionId,
      'Authorization': authorization
    }
  }
  axios(requestParams).then(res => {
    dismissLoading();
    handleResp(formData, url, res, 'upload', requestParams, success, fail);
  }).catch(error => {
    dismissLoading();
    failCallback(formData, fail, createFailRespObj(error.message));
  })
}

/** 添加公共的参数并进行加密处理 */
const commonParam = (param) => {

  param.storeId = Constant.storeId;
  param.msgId = moment().utcOffset(8).format('YYYYMMDDHHmmss') + parseInt(Math.random() * 1000000);
  param.transChannel = '00001';
  param.channelDate = moment().utcOffset(8).format('YYYYMMDD');
  param.channelTime = moment().utcOffset(8).format('HHmmss');
  param.channelSerialNo = moment().utcOffset(8).format('YYYYMMDDHHmmss') + parseInt(Math.random() * 1000000);

  let xcSession = Cache.getSsoSession();
  let clientConnSessionid = Cache.getClientConnSessionid();
  param.token = xcSession;
  // param.clientIp = '';
  // param.loginToken = '';
  let realBody = JSON.stringify(param);
  //console.log(`发起请求  body = ${JSON.stringify(param)}`);

  return realBody;
}

/** 对返回结果进行处理 */
const handleResp = (body, url, resp, type, requestParams, success, fail) => {
  let data = resp.data;
    if(body.isPrint){
      if(resp.data.type == 'application/json') {
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", function () { //
          let res = JSON.parse(reader.result); // 返回的数据
          failCallback(body, fail, res);
        });
        reader.readAsText(resp.data, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
      } else {
        dismissLoading();
        success(data);

      }
      return;
    }

  let status = resp.status;
  if (status === 200) {
    //解密成功
    if(!body.noLoading) {
      dismissLoading();
    }
    console.log('url:', url)
    console.log('params:', body)
    console.log('res:', data)
    if (data.code == HTTP_RESP_CODE.RESP_CODE_SUCCESS) {
    //   //请求服务器成功返回
      success(data);
    } else if (data.code == 80000001) {//连接token失效
      BaseHttpRequestAPI.getClientToken(Constant.appId, Constant.secret, resp => {
        let connectToken = resp.result.token;
        Cache.setClientConnSessionid(connectToken);
        //再次请求业务接口
        if (type === 'post') {
          //requestParams.headers.xc_client_sessionid = connectToken;
          postUrl(body, url, success, fail)
        } else if (type === 'upload') {
          uploadFile(body, url, success, fail)
        }else{
          downloadUrl(body, url, success, fail)
        }
      });

    } else if (data.code == 80000002 || data.code === 99994000) { //登录超时
      // store.commit('clearOpenedSubmenu');
      Cache.setUserInfo(null);
      Cache.setSsoSession(null);
      Cache.setClientConnSessionid(null);
      Cache.setPermissions(null);
      router.push({
        name: PageName.PAGE_LOGIN
      });
      failCallback(body, fail, data);
    } else {
      failCallback(body, fail, data);
    }

  } else {
    failCallback(body, fail, createFailRespObj('服务器异常'));
  }
}

/** 弹窗提示 */
const showAlert = (msg) => {
  if (global.vm) {
    global.vm.$Notice.error({
      title: '数据请求异常：',
      desc: msg,
    });
  }
}

const failCallback = (body,failCallback, resp) => {

  let status = resp.status;
  //console.info("status:" + status );
  // if(status === 406){
    //console.info("status:" + status );
    // Cache.setUserInfo('');
    // this.$store.commit('clearOpenedSubmenu');
    // this.$router.push({
    //   name: PageName.PAGE_LOGIN
    // });
  // }
  dismissLoading();
  if (resp && resp.message) {
    if (!body || !body.need) {

      showAlert(resp.message);
    }
  }
  if (failCallback) {
    failCallback(resp);
  }
}

const createFailRespObj = (errorMsg) => {
  return {message: errorMsg};
}



// WEBPACK FOOTER //
// ./src/api/ApiHelper.js